// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3wsda","header":"Messages_header__1j8ZX"};